'use strict';

angular.module('bringgApp').constant('CLUSTER_MODE_TYPES', {
	LOCATION: 1,
	INVENTORY_PICKUP: 2,
	INVENTORY_DROPOFF: 3,
	INVENTORY_PICKUP_DROPOFF: 4
});
